module.exports = __webpack_public_path__ + "img/logo_CFSG.de0eff8f.png";